/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Record Service API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { BusinessObject, CreateChildUnderParentSync201, Relationships } from "../model";

import { customFetch } from "../../../custom-fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getAllRelationshipsResponse200 = {
  data: Relationships;
  status: 200;
};

export type getAllRelationshipsResponse404 = {
  data: void;
  status: 404;
};

export type getAllRelationshipsResponseSuccess = getAllRelationshipsResponse200 & {
  headers: Headers;
};
export type getAllRelationshipsResponseError = getAllRelationshipsResponse404 & {
  headers: Headers;
};

export type getAllRelationshipsResponse =
  | getAllRelationshipsResponseSuccess
  | getAllRelationshipsResponseError;

export const getGetAllRelationshipsUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}/relationships`;
};

/**
 * @summary Get all relationships for a specific business object
 */
export const getAllRelationships = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<getAllRelationshipsResponse> => {
  return customFetch<getAllRelationshipsResponse>(
    getGetAllRelationshipsUrl(resource, resourceVersion, pk),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAllRelationshipsMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAllRelationships>>,
    TError,
    { resource: string; resourceVersion: string; pk: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAllRelationships>>,
  TError,
  { resource: string; resourceVersion: string; pk: string },
  TContext
> => {
  const mutationKey = ["getAllRelationships"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAllRelationships>>,
    { resource: string; resourceVersion: string; pk: string }
  > = (props) => {
    const { resource, resourceVersion, pk } = props ?? {};

    return getAllRelationships(resource, resourceVersion, pk, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAllRelationshipsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAllRelationships>>
>;

export type GetAllRelationshipsMutationError = void;

/**
 * @summary Get all relationships for a specific business object
 */
export const useGetAllRelationships = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAllRelationships>>,
      TError,
      { resource: string; resourceVersion: string; pk: string },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getAllRelationships>>,
  TError,
  { resource: string; resourceVersion: string; pk: string },
  TContext
> => {
  return useMutation(getGetAllRelationshipsMutationOptions(options), queryClient);
};
export type getRelationshipForRecordByRelationshipNameResponse200 = {
  data: Relationships;
  status: 200;
};

export type getRelationshipForRecordByRelationshipNameResponse404 = {
  data: void;
  status: 404;
};

export type getRelationshipForRecordByRelationshipNameResponseSuccess =
  getRelationshipForRecordByRelationshipNameResponse200 & {
    headers: Headers;
  };
export type getRelationshipForRecordByRelationshipNameResponseError =
  getRelationshipForRecordByRelationshipNameResponse404 & {
    headers: Headers;
  };

export type getRelationshipForRecordByRelationshipNameResponse =
  | getRelationshipForRecordByRelationshipNameResponseSuccess
  | getRelationshipForRecordByRelationshipNameResponseError;

export const getGetRelationshipForRecordByRelationshipNameUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}/relationships/${relationshipName}`;
};

/**
 * @summary Get relationship information for a specific relationship type
 */
export const getRelationshipForRecordByRelationshipName = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<getRelationshipForRecordByRelationshipNameResponse> => {
  return customFetch<getRelationshipForRecordByRelationshipNameResponse>(
    getGetRelationshipForRecordByRelationshipNameUrl(
      resource,
      resourceVersion,
      pk,
      relationshipName,
    ),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetRelationshipForRecordByRelationshipNameMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getRelationshipForRecordByRelationshipName>>,
    TError,
    { resource: string; resourceVersion: string; pk: string; relationshipName: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getRelationshipForRecordByRelationshipName>>,
  TError,
  { resource: string; resourceVersion: string; pk: string; relationshipName: string },
  TContext
> => {
  const mutationKey = ["getRelationshipForRecordByRelationshipName"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getRelationshipForRecordByRelationshipName>>,
    { resource: string; resourceVersion: string; pk: string; relationshipName: string }
  > = (props) => {
    const { resource, resourceVersion, pk, relationshipName } = props ?? {};

    return getRelationshipForRecordByRelationshipName(
      resource,
      resourceVersion,
      pk,
      relationshipName,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type GetRelationshipForRecordByRelationshipNameMutationResult = NonNullable<
  Awaited<ReturnType<typeof getRelationshipForRecordByRelationshipName>>
>;

export type GetRelationshipForRecordByRelationshipNameMutationError = void;

/**
 * @summary Get relationship information for a specific relationship type
 */
export const useGetRelationshipForRecordByRelationshipName = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getRelationshipForRecordByRelationshipName>>,
      TError,
      { resource: string; resourceVersion: string; pk: string; relationshipName: string },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getRelationshipForRecordByRelationshipName>>,
  TError,
  { resource: string; resourceVersion: string; pk: string; relationshipName: string },
  TContext
> => {
  return useMutation(
    getGetRelationshipForRecordByRelationshipNameMutationOptions(options),
    queryClient,
  );
};
export type getAllRelationshipsForRecordResponse200 = {
  data: Relationships;
  status: 200;
};

export type getAllRelationshipsForRecordResponse404 = {
  data: void;
  status: 404;
};

export type getAllRelationshipsForRecordResponseSuccess =
  getAllRelationshipsForRecordResponse200 & {
    headers: Headers;
  };
export type getAllRelationshipsForRecordResponseError = getAllRelationshipsForRecordResponse404 & {
  headers: Headers;
};

export type getAllRelationshipsForRecordResponse =
  | getAllRelationshipsForRecordResponseSuccess
  | getAllRelationshipsForRecordResponseError;

export const getGetAllRelationshipsForRecordUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}/relationships/${relationshipName}/${relationshipVersion}`;
};

/**
 * @summary Get all relationships of a specific type and version for a business object
 */
export const getAllRelationshipsForRecord = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<getAllRelationshipsForRecordResponse> => {
  return customFetch<getAllRelationshipsForRecordResponse>(
    getGetAllRelationshipsForRecordUrl(
      resource,
      resourceVersion,
      pk,
      relationshipName,
      relationshipVersion,
    ),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAllRelationshipsForRecordMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAllRelationshipsForRecord>>,
    TError,
    {
      resource: string;
      resourceVersion: string;
      pk: string;
      relationshipName: string;
      relationshipVersion: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAllRelationshipsForRecord>>,
  TError,
  {
    resource: string;
    resourceVersion: string;
    pk: string;
    relationshipName: string;
    relationshipVersion: string;
  },
  TContext
> => {
  const mutationKey = ["getAllRelationshipsForRecord"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAllRelationshipsForRecord>>,
    {
      resource: string;
      resourceVersion: string;
      pk: string;
      relationshipName: string;
      relationshipVersion: string;
    }
  > = (props) => {
    const { resource, resourceVersion, pk, relationshipName, relationshipVersion } = props ?? {};

    return getAllRelationshipsForRecord(
      resource,
      resourceVersion,
      pk,
      relationshipName,
      relationshipVersion,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAllRelationshipsForRecordMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAllRelationshipsForRecord>>
>;

export type GetAllRelationshipsForRecordMutationError = void;

/**
 * @summary Get all relationships of a specific type and version for a business object
 */
export const useGetAllRelationshipsForRecord = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAllRelationshipsForRecord>>,
      TError,
      {
        resource: string;
        resourceVersion: string;
        pk: string;
        relationshipName: string;
        relationshipVersion: string;
      },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getAllRelationshipsForRecord>>,
  TError,
  {
    resource: string;
    resourceVersion: string;
    pk: string;
    relationshipName: string;
    relationshipVersion: string;
  },
  TContext
> => {
  return useMutation(getGetAllRelationshipsForRecordMutationOptions(options), queryClient);
};
export type listChildrenUnderParentResponse200 = {
  data: void;
  status: 200;
};

export type listChildrenUnderParentResponse400 = {
  data: void;
  status: 400;
};

export type listChildrenUnderParentResponse403 = {
  data: void;
  status: 403;
};

export type listChildrenUnderParentResponse404 = {
  data: void;
  status: 404;
};

export type listChildrenUnderParentResponseSuccess = listChildrenUnderParentResponse200 & {
  headers: Headers;
};
export type listChildrenUnderParentResponseError = (
  | listChildrenUnderParentResponse400
  | listChildrenUnderParentResponse403
  | listChildrenUnderParentResponse404
) & {
  headers: Headers;
};

export type listChildrenUnderParentResponse =
  | listChildrenUnderParentResponseSuccess
  | listChildrenUnderParentResponseError;

export const getListChildrenUnderParentUrl = (
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
) => {
  return `/record-service/v1/${parentResource}/${parentVersion}/${parentPk}/relationships/${relationshipName}/${relationshipVersion}/children/${childResource}/${childVersion}`;
};

/**
 * Documents tab for a parent. Proves the relationship edge in the record store.
 * When the relationship is flagged securityOwnership, the caller must be able to read
 * the parent and hold GET-{parent}-{child}-OWNED. This is not a Document collection query.
 * @summary List children linked under a parent
 */
export const listChildrenUnderParent = async (
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<listChildrenUnderParentResponse> => {
  return customFetch<listChildrenUnderParentResponse>(
    getListChildrenUnderParentUrl(
      parentResource,
      parentVersion,
      parentPk,
      relationshipName,
      relationshipVersion,
      childResource,
      childVersion,
    ),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListChildrenUnderParentMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listChildrenUnderParent>>,
    TError,
    {
      parentResource: string;
      parentVersion: string;
      parentPk: string;
      relationshipName: string;
      relationshipVersion: string;
      childResource: string;
      childVersion: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listChildrenUnderParent>>,
  TError,
  {
    parentResource: string;
    parentVersion: string;
    parentPk: string;
    relationshipName: string;
    relationshipVersion: string;
    childResource: string;
    childVersion: string;
  },
  TContext
> => {
  const mutationKey = ["listChildrenUnderParent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listChildrenUnderParent>>,
    {
      parentResource: string;
      parentVersion: string;
      parentPk: string;
      relationshipName: string;
      relationshipVersion: string;
      childResource: string;
      childVersion: string;
    }
  > = (props) => {
    const {
      parentResource,
      parentVersion,
      parentPk,
      relationshipName,
      relationshipVersion,
      childResource,
      childVersion,
    } = props ?? {};

    return listChildrenUnderParent(
      parentResource,
      parentVersion,
      parentPk,
      relationshipName,
      relationshipVersion,
      childResource,
      childVersion,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ListChildrenUnderParentMutationResult = NonNullable<
  Awaited<ReturnType<typeof listChildrenUnderParent>>
>;

export type ListChildrenUnderParentMutationError = void;

/**
 * @summary List children linked under a parent
 */
export const useListChildrenUnderParent = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listChildrenUnderParent>>,
      TError,
      {
        parentResource: string;
        parentVersion: string;
        parentPk: string;
        relationshipName: string;
        relationshipVersion: string;
        childResource: string;
        childVersion: string;
      },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof listChildrenUnderParent>>,
  TError,
  {
    parentResource: string;
    parentVersion: string;
    parentPk: string;
    relationshipName: string;
    relationshipVersion: string;
    childResource: string;
    childVersion: string;
  },
  TContext
> => {
  return useMutation(getListChildrenUnderParentMutationOptions(options), queryClient);
};
export type getChildUnderParentResponse200 = {
  data: void;
  status: 200;
};

export type getChildUnderParentResponse400 = {
  data: void;
  status: 400;
};

export type getChildUnderParentResponse403 = {
  data: void;
  status: 403;
};

export type getChildUnderParentResponse404 = {
  data: void;
  status: 404;
};

export type getChildUnderParentResponseSuccess = getChildUnderParentResponse200 & {
  headers: Headers;
};
export type getChildUnderParentResponseError = (
  | getChildUnderParentResponse400
  | getChildUnderParentResponse403
  | getChildUnderParentResponse404
) & {
  headers: Headers;
};

export type getChildUnderParentResponse =
  | getChildUnderParentResponseSuccess
  | getChildUnderParentResponseError;

export const getGetChildUnderParentUrl = (
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
  childPk: string,
) => {
  return `/record-service/v1/${parentResource}/${parentVersion}/${parentPk}/relationships/${relationshipName}/${relationshipVersion}/children/${childResource}/${childVersion}/${childPk}`;
};

/**
 * Opens one child from Postgres after proving the relationship edge.
 * When the relationship is flagged securityOwnership, the caller must be able to read
 * the parent and hold GET-{parent}-{child}-OWNED. A missing edge is 404.
 * @summary Open one child linked under a parent
 */
export const getChildUnderParent = async (
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
  childPk: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<getChildUnderParentResponse> => {
  return customFetch<getChildUnderParentResponse>(
    getGetChildUnderParentUrl(
      parentResource,
      parentVersion,
      parentPk,
      relationshipName,
      relationshipVersion,
      childResource,
      childVersion,
      childPk,
    ),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetChildUnderParentMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getChildUnderParent>>,
    TError,
    {
      parentResource: string;
      parentVersion: string;
      parentPk: string;
      relationshipName: string;
      relationshipVersion: string;
      childResource: string;
      childVersion: string;
      childPk: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getChildUnderParent>>,
  TError,
  {
    parentResource: string;
    parentVersion: string;
    parentPk: string;
    relationshipName: string;
    relationshipVersion: string;
    childResource: string;
    childVersion: string;
    childPk: string;
  },
  TContext
> => {
  const mutationKey = ["getChildUnderParent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getChildUnderParent>>,
    {
      parentResource: string;
      parentVersion: string;
      parentPk: string;
      relationshipName: string;
      relationshipVersion: string;
      childResource: string;
      childVersion: string;
      childPk: string;
    }
  > = (props) => {
    const {
      parentResource,
      parentVersion,
      parentPk,
      relationshipName,
      relationshipVersion,
      childResource,
      childVersion,
      childPk,
    } = props ?? {};

    return getChildUnderParent(
      parentResource,
      parentVersion,
      parentPk,
      relationshipName,
      relationshipVersion,
      childResource,
      childVersion,
      childPk,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type GetChildUnderParentMutationResult = NonNullable<
  Awaited<ReturnType<typeof getChildUnderParent>>
>;

export type GetChildUnderParentMutationError = void;

/**
 * @summary Open one child linked under a parent
 */
export const useGetChildUnderParent = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getChildUnderParent>>,
      TError,
      {
        parentResource: string;
        parentVersion: string;
        parentPk: string;
        relationshipName: string;
        relationshipVersion: string;
        childResource: string;
        childVersion: string;
        childPk: string;
      },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getChildUnderParent>>,
  TError,
  {
    parentResource: string;
    parentVersion: string;
    parentPk: string;
    relationshipName: string;
    relationshipVersion: string;
    childResource: string;
    childVersion: string;
    childPk: string;
  },
  TContext
> => {
  return useMutation(getGetChildUnderParentMutationOptions(options), queryClient);
};
export type createChildUnderParentSyncResponse201 = {
  data: CreateChildUnderParentSync201;
  status: 201;
};

export type createChildUnderParentSyncResponse400 = {
  data: void;
  status: 400;
};

export type createChildUnderParentSyncResponse404 = {
  data: void;
  status: 404;
};

export type createChildUnderParentSyncResponse409 = {
  data: void;
  status: 409;
};

export type createChildUnderParentSyncResponseSuccess = createChildUnderParentSyncResponse201 & {
  headers: Headers;
};
export type createChildUnderParentSyncResponseError = (
  | createChildUnderParentSyncResponse400
  | createChildUnderParentSyncResponse404
  | createChildUnderParentSyncResponse409
) & {
  headers: Headers;
};

export type createChildUnderParentSyncResponse =
  | createChildUnderParentSyncResponseSuccess
  | createChildUnderParentSyncResponseError;

export const getCreateChildUnderParentSyncUrl = (
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
) => {
  return `/record-service/v1/${parentResource}/${parentVersion}/${parentPk}/relationships/${relationshipName}/${relationshipVersion}/children/${childResource}/${childVersion}/sync`;
};

/**
 * @summary Create a child record and link it under an existing parent
 */
export const createChildUnderParentSync = async (
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
  businessObject: BusinessObject,
  options?: Parameters<typeof customFetch>[1],
): Promise<createChildUnderParentSyncResponse> => {
  return customFetch<createChildUnderParentSyncResponse>(
    getCreateChildUnderParentSyncUrl(
      parentResource,
      parentVersion,
      parentPk,
      relationshipName,
      relationshipVersion,
      childResource,
      childVersion,
    ),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(businessObject),
    },
  );
};

export const getCreateChildUnderParentSyncQueryKey = (
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
  businessObject?: BusinessObject,
) => {
  return [
    "POST",
    `/record-service/v1/${parentResource}/${parentVersion}/${parentPk}/relationships/${relationshipName}/${relationshipVersion}/children/${childResource}/${childVersion}/sync`,
    businessObject,
  ] as const;
};

export const getCreateChildUnderParentSyncQueryOptions = <
  TData = Awaited<ReturnType<typeof createChildUnderParentSync>>,
  TError = void,
>(
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createChildUnderParentSync>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCreateChildUnderParentSyncQueryKey(
      parentResource,
      parentVersion,
      parentPk,
      relationshipName,
      relationshipVersion,
      childResource,
      childVersion,
      businessObject,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof createChildUnderParentSync>>> = ({
    signal,
  }) =>
    createChildUnderParentSync(
      parentResource,
      parentVersion,
      parentPk,
      relationshipName,
      relationshipVersion,
      childResource,
      childVersion,
      businessObject,
      { signal, ...requestOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled:
      parentResource !== null &&
      parentResource !== undefined &&
      parentVersion !== null &&
      parentVersion !== undefined &&
      parentPk !== null &&
      parentPk !== undefined &&
      relationshipName !== null &&
      relationshipName !== undefined &&
      relationshipVersion !== null &&
      relationshipVersion !== undefined &&
      childResource !== null &&
      childResource !== undefined &&
      childVersion !== null &&
      childVersion !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof createChildUnderParentSync>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type CreateChildUnderParentSyncQueryResult = NonNullable<
  Awaited<ReturnType<typeof createChildUnderParentSync>>
>;
export type CreateChildUnderParentSyncQueryError = void;

export function useCreateChildUnderParentSync<
  TData = Awaited<ReturnType<typeof createChildUnderParentSync>>,
  TError = void,
>(
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
  businessObject: BusinessObject,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createChildUnderParentSync>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createChildUnderParentSync>>,
          TError,
          Awaited<ReturnType<typeof createChildUnderParentSync>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateChildUnderParentSync<
  TData = Awaited<ReturnType<typeof createChildUnderParentSync>>,
  TError = void,
>(
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createChildUnderParentSync>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createChildUnderParentSync>>,
          TError,
          Awaited<ReturnType<typeof createChildUnderParentSync>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateChildUnderParentSync<
  TData = Awaited<ReturnType<typeof createChildUnderParentSync>>,
  TError = void,
>(
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createChildUnderParentSync>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Create a child record and link it under an existing parent
 */

export function useCreateChildUnderParentSync<
  TData = Awaited<ReturnType<typeof createChildUnderParentSync>>,
  TError = void,
>(
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createChildUnderParentSync>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCreateChildUnderParentSyncQueryOptions(
    parentResource,
    parentVersion,
    parentPk,
    relationshipName,
    relationshipVersion,
    childResource,
    childVersion,
    businessObject,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getRelationshipByRelPkResponse200 = {
  data: Relationships;
  status: 200;
};

export type getRelationshipByRelPkResponse404 = {
  data: void;
  status: 404;
};

export type getRelationshipByRelPkResponseSuccess = getRelationshipByRelPkResponse200 & {
  headers: Headers;
};
export type getRelationshipByRelPkResponseError = getRelationshipByRelPkResponse404 & {
  headers: Headers;
};

export type getRelationshipByRelPkResponse =
  | getRelationshipByRelPkResponseSuccess
  | getRelationshipByRelPkResponseError;

export const getGetRelationshipByRelPkUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}/relationships/${relationshipName}/${relationshipVersion}/${relPk}`;
};

/**
 * @summary Get a specific relationship by relPk for a business object
 */
export const getRelationshipByRelPk = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<getRelationshipByRelPkResponse> => {
  return customFetch<getRelationshipByRelPkResponse>(
    getGetRelationshipByRelPkUrl(
      resource,
      resourceVersion,
      pk,
      relationshipName,
      relationshipVersion,
      relPk,
    ),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetRelationshipByRelPkMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getRelationshipByRelPk>>,
    TError,
    {
      resource: string;
      resourceVersion: string;
      pk: string;
      relationshipName: string;
      relationshipVersion: string;
      relPk: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getRelationshipByRelPk>>,
  TError,
  {
    resource: string;
    resourceVersion: string;
    pk: string;
    relationshipName: string;
    relationshipVersion: string;
    relPk: string;
  },
  TContext
> => {
  const mutationKey = ["getRelationshipByRelPk"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getRelationshipByRelPk>>,
    {
      resource: string;
      resourceVersion: string;
      pk: string;
      relationshipName: string;
      relationshipVersion: string;
      relPk: string;
    }
  > = (props) => {
    const { resource, resourceVersion, pk, relationshipName, relationshipVersion, relPk } =
      props ?? {};

    return getRelationshipByRelPk(
      resource,
      resourceVersion,
      pk,
      relationshipName,
      relationshipVersion,
      relPk,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type GetRelationshipByRelPkMutationResult = NonNullable<
  Awaited<ReturnType<typeof getRelationshipByRelPk>>
>;

export type GetRelationshipByRelPkMutationError = void;

/**
 * @summary Get a specific relationship by relPk for a business object
 */
export const useGetRelationshipByRelPk = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getRelationshipByRelPk>>,
      TError,
      {
        resource: string;
        resourceVersion: string;
        pk: string;
        relationshipName: string;
        relationshipVersion: string;
        relPk: string;
      },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getRelationshipByRelPk>>,
  TError,
  {
    resource: string;
    resourceVersion: string;
    pk: string;
    relationshipName: string;
    relationshipVersion: string;
    relPk: string;
  },
  TContext
> => {
  return useMutation(getGetRelationshipByRelPkMutationOptions(options), queryClient);
};
export type createRelationshipByRelPkResponse200 = {
  data: Relationships;
  status: 200;
};

export type createRelationshipByRelPkResponse201 = {
  data: Relationships;
  status: 201;
};

export type createRelationshipByRelPkResponse404 = {
  data: void;
  status: 404;
};

export type createRelationshipByRelPkResponseSuccess = (
  | createRelationshipByRelPkResponse200
  | createRelationshipByRelPkResponse201
) & {
  headers: Headers;
};
export type createRelationshipByRelPkResponseError = createRelationshipByRelPkResponse404 & {
  headers: Headers;
};

export type createRelationshipByRelPkResponse =
  | createRelationshipByRelPkResponseSuccess
  | createRelationshipByRelPkResponseError;

export const getCreateRelationshipByRelPkUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}/relationships/${relationshipName}/${relationshipVersion}/${relPk}`;
};

/**
 * @summary Create a specific relationship by relPk
 */
export const createRelationshipByRelPk = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<createRelationshipByRelPkResponse> => {
  return customFetch<createRelationshipByRelPkResponse>(
    getCreateRelationshipByRelPkUrl(
      resource,
      resourceVersion,
      pk,
      relationshipName,
      relationshipVersion,
      relPk,
    ),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCreateRelationshipByRelPkQueryKey = (
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
) => {
  return [
    "POST",
    `/record-service/v1/${resource}/${resourceVersion}/${pk}/relationships/${relationshipName}/${relationshipVersion}/${relPk}`,
  ] as const;
};

export const getCreateRelationshipByRelPkQueryOptions = <
  TData = Awaited<ReturnType<typeof createRelationshipByRelPk>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createRelationshipByRelPk>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCreateRelationshipByRelPkQueryKey(
      resource,
      resourceVersion,
      pk,
      relationshipName,
      relationshipVersion,
      relPk,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof createRelationshipByRelPk>>> = ({
    signal,
  }) =>
    createRelationshipByRelPk(
      resource,
      resourceVersion,
      pk,
      relationshipName,
      relationshipVersion,
      relPk,
      { signal, ...requestOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      pk !== null &&
      pk !== undefined &&
      relationshipName !== null &&
      relationshipName !== undefined &&
      relationshipVersion !== null &&
      relationshipVersion !== undefined &&
      relPk !== null &&
      relPk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof createRelationshipByRelPk>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type CreateRelationshipByRelPkQueryResult = NonNullable<
  Awaited<ReturnType<typeof createRelationshipByRelPk>>
>;
export type CreateRelationshipByRelPkQueryError = void;

export function useCreateRelationshipByRelPk<
  TData = Awaited<ReturnType<typeof createRelationshipByRelPk>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createRelationshipByRelPk>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createRelationshipByRelPk>>,
          TError,
          Awaited<ReturnType<typeof createRelationshipByRelPk>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateRelationshipByRelPk<
  TData = Awaited<ReturnType<typeof createRelationshipByRelPk>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createRelationshipByRelPk>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createRelationshipByRelPk>>,
          TError,
          Awaited<ReturnType<typeof createRelationshipByRelPk>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateRelationshipByRelPk<
  TData = Awaited<ReturnType<typeof createRelationshipByRelPk>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createRelationshipByRelPk>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Create a specific relationship by relPk
 */

export function useCreateRelationshipByRelPk<
  TData = Awaited<ReturnType<typeof createRelationshipByRelPk>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createRelationshipByRelPk>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCreateRelationshipByRelPkQueryOptions(
    resource,
    resourceVersion,
    pk,
    relationshipName,
    relationshipVersion,
    relPk,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type updateRelationshipByRelPkResponse200 = {
  data: Relationships;
  status: 200;
};

export type updateRelationshipByRelPkResponse404 = {
  data: void;
  status: 404;
};

export type updateRelationshipByRelPkResponseSuccess = updateRelationshipByRelPkResponse200 & {
  headers: Headers;
};
export type updateRelationshipByRelPkResponseError = updateRelationshipByRelPkResponse404 & {
  headers: Headers;
};

export type updateRelationshipByRelPkResponse =
  | updateRelationshipByRelPkResponseSuccess
  | updateRelationshipByRelPkResponseError;

export const getUpdateRelationshipByRelPkUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}/relationships/${relationshipName}/${relationshipVersion}/${relPk}`;
};

/**
 * @summary Update a specific relationship by relPk
 */
export const updateRelationshipByRelPk = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<updateRelationshipByRelPkResponse> => {
  return customFetch<updateRelationshipByRelPkResponse>(
    getUpdateRelationshipByRelPkUrl(
      resource,
      resourceVersion,
      pk,
      relationshipName,
      relationshipVersion,
      relPk,
    ),
    {
      ...options,
      method: "PUT",
    },
  );
};

export const getUpdateRelationshipByRelPkQueryKey = (
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
) => {
  return [
    "PUT",
    `/record-service/v1/${resource}/${resourceVersion}/${pk}/relationships/${relationshipName}/${relationshipVersion}/${relPk}`,
  ] as const;
};

export const getUpdateRelationshipByRelPkQueryOptions = <
  TData = Awaited<ReturnType<typeof updateRelationshipByRelPk>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateRelationshipByRelPk>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getUpdateRelationshipByRelPkQueryKey(
      resource,
      resourceVersion,
      pk,
      relationshipName,
      relationshipVersion,
      relPk,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof updateRelationshipByRelPk>>> = ({
    signal,
  }) =>
    updateRelationshipByRelPk(
      resource,
      resourceVersion,
      pk,
      relationshipName,
      relationshipVersion,
      relPk,
      { signal, ...requestOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      pk !== null &&
      pk !== undefined &&
      relationshipName !== null &&
      relationshipName !== undefined &&
      relationshipVersion !== null &&
      relationshipVersion !== undefined &&
      relPk !== null &&
      relPk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof updateRelationshipByRelPk>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type UpdateRelationshipByRelPkQueryResult = NonNullable<
  Awaited<ReturnType<typeof updateRelationshipByRelPk>>
>;
export type UpdateRelationshipByRelPkQueryError = void;

export function useUpdateRelationshipByRelPk<
  TData = Awaited<ReturnType<typeof updateRelationshipByRelPk>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateRelationshipByRelPk>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateRelationshipByRelPk>>,
          TError,
          Awaited<ReturnType<typeof updateRelationshipByRelPk>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateRelationshipByRelPk<
  TData = Awaited<ReturnType<typeof updateRelationshipByRelPk>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateRelationshipByRelPk>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateRelationshipByRelPk>>,
          TError,
          Awaited<ReturnType<typeof updateRelationshipByRelPk>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateRelationshipByRelPk<
  TData = Awaited<ReturnType<typeof updateRelationshipByRelPk>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateRelationshipByRelPk>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Update a specific relationship by relPk
 */

export function useUpdateRelationshipByRelPk<
  TData = Awaited<ReturnType<typeof updateRelationshipByRelPk>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateRelationshipByRelPk>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUpdateRelationshipByRelPkQueryOptions(
    resource,
    resourceVersion,
    pk,
    relationshipName,
    relationshipVersion,
    relPk,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type deleteRelationshipByRelPkResponse204 = {
  data: void;
  status: 204;
};

export type deleteRelationshipByRelPkResponse404 = {
  data: void;
  status: 404;
};

export type deleteRelationshipByRelPkResponseSuccess = deleteRelationshipByRelPkResponse204 & {
  headers: Headers;
};
export type deleteRelationshipByRelPkResponseError = deleteRelationshipByRelPkResponse404 & {
  headers: Headers;
};

export type deleteRelationshipByRelPkResponse =
  | deleteRelationshipByRelPkResponseSuccess
  | deleteRelationshipByRelPkResponseError;

export const getDeleteRelationshipByRelPkUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}/relationships/${relationshipName}/${relationshipVersion}/${relPk}`;
};

/**
 * @summary Delete a specific relationship by relPk
 */
export const deleteRelationshipByRelPk = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<deleteRelationshipByRelPkResponse> => {
  return customFetch<deleteRelationshipByRelPkResponse>(
    getDeleteRelationshipByRelPkUrl(
      resource,
      resourceVersion,
      pk,
      relationshipName,
      relationshipVersion,
      relPk,
    ),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteRelationshipByRelPkQueryKey = (
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
) => {
  return [
    "DELETE",
    `/record-service/v1/${resource}/${resourceVersion}/${pk}/relationships/${relationshipName}/${relationshipVersion}/${relPk}`,
  ] as const;
};

export const getDeleteRelationshipByRelPkQueryOptions = <
  TData = Awaited<ReturnType<typeof deleteRelationshipByRelPk>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteRelationshipByRelPk>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDeleteRelationshipByRelPkQueryKey(
      resource,
      resourceVersion,
      pk,
      relationshipName,
      relationshipVersion,
      relPk,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteRelationshipByRelPk>>> = ({
    signal,
  }) =>
    deleteRelationshipByRelPk(
      resource,
      resourceVersion,
      pk,
      relationshipName,
      relationshipVersion,
      relPk,
      { signal, ...requestOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      pk !== null &&
      pk !== undefined &&
      relationshipName !== null &&
      relationshipName !== undefined &&
      relationshipVersion !== null &&
      relationshipVersion !== undefined &&
      relPk !== null &&
      relPk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof deleteRelationshipByRelPk>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type DeleteRelationshipByRelPkQueryResult = NonNullable<
  Awaited<ReturnType<typeof deleteRelationshipByRelPk>>
>;
export type DeleteRelationshipByRelPkQueryError = void;

export function useDeleteRelationshipByRelPk<
  TData = Awaited<ReturnType<typeof deleteRelationshipByRelPk>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteRelationshipByRelPk>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteRelationshipByRelPk>>,
          TError,
          Awaited<ReturnType<typeof deleteRelationshipByRelPk>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteRelationshipByRelPk<
  TData = Awaited<ReturnType<typeof deleteRelationshipByRelPk>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteRelationshipByRelPk>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteRelationshipByRelPk>>,
          TError,
          Awaited<ReturnType<typeof deleteRelationshipByRelPk>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteRelationshipByRelPk<
  TData = Awaited<ReturnType<typeof deleteRelationshipByRelPk>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteRelationshipByRelPk>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Delete a specific relationship by relPk
 */

export function useDeleteRelationshipByRelPk<
  TData = Awaited<ReturnType<typeof deleteRelationshipByRelPk>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  relationshipName: string,
  relationshipVersion: string,
  relPk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteRelationshipByRelPk>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDeleteRelationshipByRelPkQueryOptions(
    resource,
    resourceVersion,
    pk,
    relationshipName,
    relationshipVersion,
    relPk,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
